import { Flex } from '@modusign/design-system';
import { ReactNode } from 'react';

import HelpButton from '@app/components/HelpButton';
import useResponsiveValue from '@app/hooks/useResponsiveValue';

interface LocalHeaderProps {
  children: ReactNode;
  isHelpBtn: boolean;
  onHelp?: () => void;
}

const defaultProps = {
  isHelpBtn: false,
};

function LocalHeader({ children, isHelpBtn, onHelp }: LocalHeaderProps) {
  const isDesktop = useResponsiveValue([false, false, true]);
  return (
    <Flex
      alignItems="center"
      as="header"
      backgroundColor="white"
      borderBottomColor="boxBorderNeutralBase"
      borderBottomStyle="solid"
      borderBottomWidth="1px"
      height="60px"
      justifyContent="space-between"
      minHeight="60px"
      overflow="hidden"
      pl={[6, null, 9]}
      pr={[6, null, 7]}
    >
      {children}
      {isDesktop && isHelpBtn && <HelpButton variant="basic" onClick={onHelp} />}
    </Flex>
  );
}

LocalHeader.defaultProps = defaultProps;

export default LocalHeader;
